import { NgIf } from '@angular/common';
import {
    Directive,
    EmbeddedViewRef,
    EventEmitter,
    Input,
    //OnDestroy,
    Output,
    TemplateRef,
    ViewContainerRef
} from '@angular/core';

/**
 * The "animationend" event won't be fired if the element doesn't have animation applied to it.
 * This utility function uses a timeout as a fallback to ensure the callback is fired.
 */
function animationEndSafe(el: Element, maxWait: number): Promise<any> {
    return new Promise((resolve, reject) => {
        el.addEventListener('animationend', resolve);
        setTimeout(resolve, maxWait);
    });
}

@Directive({
    selector: '[showRolesIf]',
    standalone: false
})

export class ShowRolesIfDirective extends NgIf {
    private visible = false;

    @Input()
    set showRolesIf(roles: string) {
        var userHasRole = false;
        var splitRoles = roles.split(',');
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        for (var i = 0; i < splitRoles.length; i++) {
            if (employeeRoles != null && employeeRoles!.indexOf(splitRoles[i].trim()) > -1) {
                userHasRole = true;
            }
        }

        if (this.visible && !userHasRole) {
            this.hide();
        } else if (!this.visible && userHasRole) {
            this.show();
        }

        this.visible = userHasRole;
    }

    @Output() animatedIfOnShow = new EventEmitter<any>(false);
    @Output() animatedIfOnHide = new EventEmitter<any>(false);

    constructor(private viewContainer: ViewContainerRef, _templateRef: TemplateRef<any>) {
        super(viewContainer, _templateRef);

        // any extra initialization goes here...
    }

    private getContainer(): HTMLElement | null {
        if (this.viewContainer.length > 0) {
            return (this.viewContainer.get(0) as EmbeddedViewRef<any>).rootNodes[0];
        } else {
            return null;
        }
    }

    /**
     * Hides the element. Animation is performed through css on the container.
     * This method will set the class to hiding and preserve the element for the animation duration.
     */
    private hide() {
        let container = this.getContainer();
        if (!!container) {
            container.classList.remove('showing');
            container.classList.add('hiding');

            animationEndSafe(container, 1000).then(() => {
                this.ngIf = this.visible;
                container!.classList.remove('hiding');
            });

            this.animatedIfOnHide.emit();
        }
    }

    /**
     * Shows the element. Animation is performed through css on the container
     */
    private show() {
        this.ngIf = true;

        let container = this.getContainer();
        if (!!container) {
            container.classList.remove('hiding');
            container.classList.add('showing');


            animationEndSafe(container, 1000).then(() => {
                container!.classList.remove('showing');
            });

            this.animatedIfOnShow.emit();
        }
    }
}

@Directive({
    selector: '[hideRolesIf]',
    standalone: false
})

export class HideRolesIfDirective extends NgIf {
    private visible = false;

    @Input()
    set hideRolesIf(roles: string) {
        var userHasRole = false;
        var splitRoles = roles.split(',');
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        for (var i = 0; i < splitRoles.length; i++) {
            if (employeeRoles!.indexOf(splitRoles[i].trim()) > -1) {
                userHasRole = true;
            }
        }

        if (this.visible && userHasRole) {
            this.hide();
        } else if (!this.visible && !userHasRole) {
            this.show();
        }

        this.visible = !userHasRole;
    }

    @Output() animatedIfOnShow = new EventEmitter<any>(false);
    @Output() animatedIfOnHide = new EventEmitter<any>(false);

    constructor(private viewContainer: ViewContainerRef, _templateRef: TemplateRef<any>) {
        super(viewContainer, _templateRef);

        // any extra initialization goes here...
    }

    private getContainer(): HTMLElement | null {
        if (this.viewContainer.length > 0) {
            return (this.viewContainer.get(0) as EmbeddedViewRef<any>).rootNodes[0];
        } else {
            return null;
        }
    }

    /**
     * Hides the element. Animation is performed through css on the container.
     * This method will set the class to hiding and preserve the element for the animation duration.
     */
    private hide() {
        let container = this.getContainer();
        if (!!container) {
            container.classList.remove('showing');
            container.classList.add('hiding');

            animationEndSafe(container, 1000).then(() => {
                this.ngIf = this.visible;
                container!.classList.remove('hiding');
            });

            this.animatedIfOnHide.emit();
        }
    }

    /**
     * Shows the element. Animation is performed through css on the container
     */
    private show() {
        this.ngIf = true;

        let container = this.getContainer();
        if (!!container) {
            container.classList.remove('hiding');
            container.classList.add('showing');


            animationEndSafe(container, 1000).then(() => {
                container!.classList.remove('showing');
            });

            this.animatedIfOnShow.emit();
        }
    }
}